<div class="ant-select-item-option-content">
  <ng-container *ngIf="!customContent">{{ label }}</ng-container>
  <ng-container *ngIf="customContent">
    <ng-template [ngTemplateOutlet]="template"></ng-template>
  </ng-container>
</div>
<div *ngIf="showState && selected" class="ant-select-item-option-state" style="user-select: none" unselectable="on">
  <i nz-icon nzType="check" class="ant-select-selected-icon" *ngIf="!icon; else icon"></i>
</div>
